var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 8C5 7.86739 5.05268 7.74021 5.14645 7.64645C5.24021 7.55268 5.36739 7.5 5.5 7.5H10V4.25C10 3.25 8.94406 2.5 8 2.5H3.25C2.78602 2.5005 2.34119 2.68503 2.01311 3.01311C1.68503 3.34119 1.5005 3.78602 1.5 4.25V11.75C1.5005 12.214 1.68503 12.6588 2.01311 12.9869C2.34119 13.315 2.78602 13.4995 3.25 13.5H8.25C8.71398 13.4995 9.15881 13.315 9.48689 12.9869C9.81497 12.6588 9.9995 12.214 10 11.75V8.5H5.5C5.36739 8.5 5.24021 8.44732 5.14645 8.35355C5.05268 8.25979 5 8.13261 5 8Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3534 7.64654L11.8534 5.14654C11.7589 5.05673 11.633 5.0074 11.5027 5.00907C11.3723 5.01074 11.2477 5.06328 11.1555 5.15548C11.0633 5.24768 11.0108 5.37225 11.0091 5.50263C11.0074 5.63301 11.0568 5.75889 11.1466 5.85342L12.7928 7.49998H10V8.49998H12.7928L11.1466 10.1465C11.0982 10.1925 11.0595 10.2477 11.0328 10.3089C11.006 10.37 10.9918 10.4359 10.991 10.5026C10.9901 10.5694 11.0026 10.6356 11.0278 10.6974C11.0529 10.7592 11.0902 10.8154 11.1374 10.8626C11.1846 10.9098 11.2407 10.947 11.3026 10.9722C11.3644 10.9973 11.4306 11.0098 11.4973 11.009C11.5641 11.0081 11.63 10.9939 11.6911 10.9672C11.7523 10.9405 11.8075 10.9018 11.8534 10.8534L14.3534 8.35342C14.4471 8.25966 14.4998 8.13253 14.4998 7.99998C14.4998 7.86743 14.4471 7.7403 14.3534 7.64654Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOut);
export default __webpack_public_path__ + "static/media/logOut.5f4c772a9803de8c82754103bb58eea0.svg";
export { ForwardRef as ReactComponent };